var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-page-base", { attrs: { title: "Certificado digital" } }, [
    _c("h2", { staticClass: "subtitle" }, [
      _c("span", [
        _vm._v(
          "Adicione seus certificados digitais de acordo com o centro de distribuição, assim a gente consegue buscar os CT-es de maneira segura e ágil direto na SEFAZ."
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("sc-table", {
          attrs: {
            loading: _vm.loadingWarehouses,
            data: _vm.warehouses,
            paginated: _vm.isPaginated,
            perPage: _vm.perPage,
            bordered: false,
            hoverable: false,
            striped: false,
            scrollable: false
          },
          on: {
            "update:perPage": function($event) {
              _vm.perPage = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var row = ref.row
                var index = ref.index
                return [
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Centro de distribuição",
                        centered: false
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(row.warehouse_name) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Código", centered: false } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(row.warehouse_code) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "CEP", centered: false } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("cep")(row.warehouse_zipcode)) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "CNPJ", centered: false } },
                    [
                      row.warehouse_federal_tax_id
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("cnpj")(row.warehouse_federal_tax_id)
                                ) +
                                "\n          "
                            )
                          ])
                        : _c("span", [_vm._v(" - ")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Status", centered: false } },
                    [
                      _c("sc-tag", { attrs: { size: "is-medium" } }, [
                        row.configuration_state === "CONFIGURED"
                          ? _c("span", [
                              _c("i", {
                                staticClass: "fas fa-circle configured-icon"
                              }),
                              _vm._v(
                                "\n              Adicionado - " +
                                  _vm._s(
                                    _vm._f("utcDate")(
                                      row.configuration_date,
                                      "DD/MM/YY - HH:mm"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("span", [
                              _vm._v("Nenhum certificado adicionado")
                            ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Ações" } },
                    [
                      _c(
                        "sc-dropdown",
                        {
                          attrs: { position: _vm.getActionMenuPosition(index) }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "field",
                              attrs: { slot: "trigger" },
                              slot: "trigger"
                            },
                            [_c("i", { staticClass: "fas fa-ellipsis-v" })]
                          ),
                          _vm._v(" "),
                          row.configuration_state === "CONFIGURED"
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "sc-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.openAddCertificateModal(row, true)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "far fa-times-circle"
                                      }),
                                      _vm._v(
                                        " Atualizar certificado\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "sc-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.openExcludeCertificateModal(row)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "far fa-times-circle"
                                      }),
                                      _vm._v(
                                        " Excluir certificado\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c(
                                "sc-dropdown-item",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.openAddCertificateModal(row, false)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-plus-circle"
                                  }),
                                  _vm._v(" Adicionar certificado\n            ")
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("sc-add-cnpj-modal", {
          attrs: {
            isActive: _vm.isAddCnpjModalActive,
            warehouse_config: _vm.currentWarehouseSelected,
            closeCallback: function() {
              return _vm.handleCloseModal("isAddCnpjModalActive")
            },
            continueCallback: _vm.handleAddCnpj
          }
        }),
        _vm._v(" "),
        _c("sc-add-certificate-modal", {
          attrs: {
            isActive: _vm.isAddCertificateModalActive,
            isLoading: _vm.currentModalLoading === "addCertificate",
            closeCallback: function() {
              return _vm.handleCloseModal("isAddCertificateModalActive")
            },
            finishCallback: _vm.handleAddCertificate
          }
        }),
        _vm._v(" "),
        _c("sc-exclude-certificate-modal", {
          attrs: {
            isActive: _vm.isExcludeModalActive,
            closeCallback: function() {
              return _vm.handleCloseModal("isExcludeModalActive")
            },
            excludeCallback: _vm.handleExcludeCertificate
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ae2de16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae2de16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/PageConfigurationSefaz.vue
// module id = null
// module chunks = 